import styles from "./LeadCommunicationsPanel.module.css";

const formatDate = (date) => {
  if (!date) return "-";

  return new Date(date).toLocaleDateString("es-AR", {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
  });
};

const CommunicationCard = ({
  recipient,
  communication,
  selected = false,
  onSelect,
}) => {
  if (!communication) return null;

  const referencePerson =
    recipient?.name ||
    communication?.from_name ||
    "Sin contacto";

  const subject =
    communication?.subject ||
    communication?.normalized_subject ||
    "Sin asunto";

  const repliesCount = communication?.total_replies || 0;
  const hasUnread = Boolean(communication?.has_unread);

  return (
    <button
      type="button"
      className={`${styles.communicationCard} ${
        selected ? styles.communicationCardSelected : ""
      }`}
      onClick={() => onSelect?.(communication)}
    >
      <div className={styles.cardContent}>
        <div className={styles.cardHeader}>
          <div className={styles.headerLeft}>
            {hasUnread && (
              <span
                className={styles.unreadDot}
                role="status"
                aria-label="Tiene correos sin leer"
              />
            )}
            <span className={styles.senderName}>{referencePerson}</span>
            <span className={styles.communicationDate}>
              {formatDate(communication?.last_reply_at)}
            </span>
          </div>

          <span className={styles.unreadBadge}>
            <span className={styles.unreadCount}>{repliesCount}</span>
          </span>
        </div>

        <div className={styles.subjectContainer}>
          <span className={styles.subject}>{subject}</span>
        </div>
      </div>
    </button>
  );
};

export default CommunicationCard;
